import React from "react";
import DataStatisticsTable from "components/Table/DataStatisticsTable";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import { Button } from "components/ui/button";

interface TableHeader {
  key: string;
  label: string;
}

interface CampaignModalProps {
  isOpen: boolean;
  onClose: () => void;
  tableHeaders: TableHeader[];
  tableData: Record<string, any>[];
  title?: string;
  description?: string;
}

const CampaignModal: React.FC<CampaignModalProps> = ({
  isOpen,
  onClose,
  tableHeaders,
  tableData,
  title = "All Campaigns",
  description,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl p-0 overflow-hidden">
        <DialogHeader className="px-6 pt-6">
          <DialogTitle>{title}</DialogTitle>
          {description ? (
            <DialogDescription>{description}</DialogDescription>
          ) : null}
        </DialogHeader>

        <div className="max-h-[calc(90vh-180px)] overflow-y-auto px-6 pb-2">
          <div className="rounded-lg border border-border/60 bg-card">
            <DataStatisticsTable headers={tableHeaders} data={tableData} />
          </div>
        </div>

        <DialogFooter className="px-6 pb-6 pt-2">
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CampaignModal;
